module.exports = __webpack_public_path__ + "img/icon_map_3_yj_hg_c.13fb7309.png";